export default function CCalloc() {
  return <h2>C Calloc</h2>;
}
